
/**
 * --- External Imports ---
 */
import { Field, Input } from "@ngt/forms-core";
import { FC, HTMLInputTypeAttribute } from "react";

/**
 * --- Internal Imports ---
 */
import { TextFieldFormField } from "../../../../api/dtos/dtos";
import InputTextField from "../InputTextField";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";
import { Box } from "@mui/material";


/**
 * --- Input Field ---
 */
interface IInputFieldTextProps {
    field: TextFieldFormField;
}

const InputFieldText: FC<IInputFieldTextProps> = ({
    field
}) => {

    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Box
                    sx={{
                        width: '100%'
                    }}
                >
                    <Input
                        id={field.name}
                        component={InputTextField} 
                        fullWidth
                        size='small'
                        type={field.textFieldType as HTMLInputTypeAttribute}
                        placeholder={field.placeholder ?? undefined}
                    />
                </Box>
            }
        />
    )
}

/**
 * --- Species Form Text Field ---
 * 
 * Wrapper for the "TextFieldFormField" element in a species form. Wraps the 
 * custom implementation of the "@ngt/forms-core" text field with a styled
 * field control label for styling.
 */
const FormFieldTextField: FC<IFormFieldComponentProps<TextFieldFormField>> = ({
    field,
    form
}) => {
    return (
        <Field propertyPath={`${form.name}.${field.name}`}>
            <InputFieldText field={field}/>
            <FieldErrors />
        </Field>
    );
}

export default FormFieldTextField;